import { render } from "./EnterGame.vue?vue&type=template&id=a2531d06&scoped=true"
import script from "./EnterGame.vue?vue&type=script&lang=js"
export * from "./EnterGame.vue?vue&type=script&lang=js"

import "./EnterGame.vue?vue&type=style&index=0&id=a2531d06&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2531d06"]])

export default __exports__